import type { ScheduledQuotesActivity } from 'apiConnector/scheduledRun/model';
import type { IScheduledQuotesBlotterItem } from 'apiConnector/scheduledRun/scheduledQuotesBlotter';
import type { IBlotterPreferenceState } from 'components/shared/Blotter/Grid/blotter.model';
import type { IBlotterColumnDefinition, Sort } from 'state/blotters/common/blotter.model';

export const SCHEDULE_PANEL_TAB = ['overview', 'quotes', 'schedules'] as const;
export type SchedulePanelTab = (typeof SCHEDULE_PANEL_TAB)[number];
export interface IScheduledQuotesBlotterFilters {
  quickSearchTerm: string | undefined;
  activityFilter: ScheduledQuotesActivity;
}
export interface IScheduledQuotesBlotter {
  blotterPreferenceState: IBlotterPreferenceState;
  areBlotterPreferencesInError: boolean;
  canSaveBlotterPreferences: boolean;
  isBlotterPreferenceStatePersistenceFailed: boolean;

  columnDefinition: readonly IBlotterColumnDefinition<IScheduledQuotesBlotterItem>[];
  isFetchingFailed: boolean;
  isFiltersLoadingFailed?: boolean;
  items: readonly IScheduledQuotesBlotterItem[];
  loading: boolean;
  error: boolean;
  page: number;
  sort: readonly Sort[];
  totalItems?: number;
  totalPages?: number;
  filters: IScheduledQuotesBlotterFilters;
  selectedRowId?: string;

  selectedPanelTab: SchedulePanelTab;
}

export type ScheduledQuotesBlotterState = Readonly<IScheduledQuotesBlotter>;

export const initialScheduledQuoteBlotterFilters: IScheduledQuotesBlotterFilters = {
  quickSearchTerm: '',
  activityFilter: 'mySelf',
};

export const initialScheduledQuotesBlotterState: ScheduledQuotesBlotterState = {
  filters: initialScheduledQuoteBlotterFilters,
  page: 1,
  loading: true,
  error: false,
  blotterPreferenceState: {
    columnState: [],
    pageSizeState: 1000,
  },
  sort: [],
  columnDefinition: [],
  isFetchingFailed: false,
  isFiltersLoadingFailed: false,
  isBlotterPreferenceStatePersistenceFailed: false,
  areBlotterPreferencesInError: false,
  canSaveBlotterPreferences: false,
  items: [],
  selectedPanelTab: 'overview',
};
